import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

export function getIsHomePage(content: CmsApiPage) {
  return Boolean(content && ['en', 'es', 'pt'].includes(content.url));
}
